import { render } from "./Upload.vue?vue&type=template&id=2abd88cc&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=2abd88cc&lang=less&scoped=true"

import exportComponent from "D:\\code\\m_pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abd88cc"]])

export default __exports__